import React, { useEffect, useState } from "react";
import SelectReact from "react-select";
import { ApiResponse } from "Types/OSM/Response";

export type PerihalOption = {
  value: number;
  label: string;
  kode?: string;
  nama?: string;
};

interface PerihalSelectProps {
  value: PerihalOption | null;
  onChange: (value: PerihalOption | null) => void;
  placeholder?: string;
  initialValueId?: number | null;
}

const PerihalSelect = ({
  value,
  onChange,
  placeholder = "Ketik untuk mencari ...",
  initialValueId,
}: PerihalSelectProps) => {
  const [options, setOptions] = useState<PerihalOption[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchPerihal = async () => {
      try {
        setLoading(true);
        const res = await fetch("/api/doServices", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            method: "GET",
            endpoint: `office/klasifikasi?page=1&limit=1000`,
            isForm: false,
            isImage: false,
          }),
        });

        if (!res.ok) {
          setLoading(false);
          return;
        }

        const result = (await res.json()) as ApiResponse;
        if (result.http_code !== 200 || !Array.isArray(result.data)) {
          setLoading(false);
          return;
        }

        const opts: PerihalOption[] = result.data.map((item: any) => ({
          value: item.id,
          label: `${item.kode ?? ""} - ${item.nama ?? ""}`,
          kode: item.kode,
          nama: item.nama,
        }));

        setOptions(opts);

        // Auto-select berdasarkan initialValueId
        if (initialValueId && !value) {
          const foundOption = opts.find(opt => opt.value === initialValueId);
          console.log("PerihalSelect auto-select:", {
            initialValueId,
            foundOption,
            currentValue: value,
            allOptions: opts.slice(0, 5), // Show first 5 options for debugging
          });
          if (foundOption) {
            onChange(foundOption);
          }
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetch perihal:", err);
        setLoading(false);
      }
    };

    fetchPerihal();
  }, [initialValueId, onChange, value]);

  return (
    <SelectReact
      isMulti={false}
      isLoading={loading}
      options={options}
      value={value}
      onChange={(val) => onChange(val as PerihalOption | null)}
      placeholder={placeholder}
      classNamePrefix="react-select"
    />
  );
};

export default PerihalSelect;